import React from "react";
import { camelCaseToWords } from "../../services/Utils";
import { HorizontalStack, SmartContainer } from "../../styles/Containers";
import { FormSelect } from "../Forms/FormSelect";

export const OrderBy = ({ options, value, onChange }) => {

    const handleColumnChange = (v) => {
        const x = {
            column: v,
            direction: value?.direction
        }
        onChange(x);
    }

    const handleDirectionChange = (v) => {
        const x = {
            column: value?.column,
            direction: v
        }
        onChange(x);
    }

    return (
        <HorizontalStack flex minWidth="300px">
            <FormSelect label="Sort by" name="column" value={value?.column} onChange={handleColumnChange}>
                {options?.map(opt => (<option key={opt} value={opt}>{camelCaseToWords(opt)}</option>))}
            </FormSelect>
            <FormSelect label="Sort order" name="direction" value={value?.direction} onChange={handleDirectionChange}>
                <option key="asc" value="ASC">ASC</option>
                <option key="desc" value="DESC">DESC</option>
            </FormSelect>
        </HorizontalStack>
    )
}